<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    forecaster: {
      type: Object,
      required: true
    },
  });

  const forecasterBioUrl = computed(() => props.forecaster ? `https://tempest.earth/forecasters/${props.forecaster.bio_slug}/` : null);

</script>

<template>
  <p v-if="forecasterBioUrl" class="jwx-pro-forecast__credits jwx-font-size-sm">Prepared by meteorologist <a :href="forecasterBioUrl" target="_blank" class="jwx-pro-forecast__credits-author">{{ props.forecaster.name }}</a></p>
  <p v-else class="jwx-pro-forecast__credits jwx-font-size-sm">Prepared by meteorologist <span class="jwx-pro-forecast__credits-author">{{ props.forecaster.name }}</span></p>
</template>